var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 17,
    viewBox: "0 0 100 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23877 8.63979C2.23877 8.63979 7.58952 0.244268 13.7462 8.63979C19.9029 17.0353 25.7686 8.63979 25.7686 8.63979C25.7686 8.63979 31.888 0.244268 38.0597 8.63979C44.2313 17.0353 49.3283 8.63979 49.3283 8.63979C49.3283 8.63979 54.6492 0.244268 60.8059 8.63979C66.9627 17.0353 74.2388 8.63979 74.2388 8.63979C74.2388 8.63979 80.3432 0.244268 86.5 8.63979C92.6567 17.0353 97.7612 8.63979 97.7612 8.63979",
    stroke: "#FF9D00",
    strokeWidth: 3.73134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcik);
export default __webpack_public_path__ + "static/media/gcik.108b2448fa4a92fcf1d8984e36561bb5.svg";
export { ForwardRef as ReactComponent };